module.exports = __webpack_public_path__ + "img/terms-grid-1.d5abf83c.svg";